import axios from 'axios'
import type {
  AllowedUserDto,
  AddAllowedUserRequest,
  UpdateAllowedUserRequest,
  BulkImportResultDto,
  InitiateFeedbackRequest,
  PendingFeedbackDto,
  SubmitFeedbackRequest,
  FeedbackListRequest,
  PagedFeedbackResult,
} from './types'

const API_URL = process.env.REACT_APP_API_URL
const BASE = `${API_URL}/ai-interpretation`

// ASP.NET FromQuery binds List<string> from repeated keys: ?interpreters=A&interpreters=B
const feedbackParamsSerializer = (params: Record<string, unknown>) => {
  const parts: string[] = []
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue
    if (Array.isArray(value)) {
      for (const v of value) {
        if (v === undefined || v === null || v === '') continue
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`)
      }
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    }
  }
  return parts.join('&')
}

export const aiInterpApi = {
  listAllowed: () =>
    axios.get<AllowedUserDto[]>(`${BASE}/allowed`).then(r => r.data),

  addAllowed: (req: AddAllowedUserRequest) =>
    axios.post<AllowedUserDto>(`${BASE}/allowed`, req).then(r => r.data),

  updateAllowed: (id: number, req: UpdateAllowedUserRequest) =>
    axios.put<AllowedUserDto>(`${BASE}/allowed/${id}`, req).then(r => r.data),

  removeAllowed: (id: number) =>
    axios.delete<void>(`${BASE}/allowed/${id}`).then(() => undefined),

  bulkImport: (file: File) => {
    const fd = new FormData()
    fd.append('file', file)
    return axios.post<BulkImportResultDto>(`${BASE}/allowed/bulk-import`, fd).then(r => r.data)
  },

  initiateFeedback: (req: InitiateFeedbackRequest) =>
    axios.post<{ submissionId: number }>(`${BASE}/feedback/initiate`, req).then(r => r.data),

  getPending: () =>
    axios.get<PendingFeedbackDto | ''>(`${BASE}/feedback/pending`).then(r =>
      r.status === 204 || !r.data ? null : r.data
    ),

  submit: (req: SubmitFeedbackRequest) =>
    axios.post<void>(`${BASE}/feedback/submit`, req).then(() => undefined),

  listSubmitted: (req: FeedbackListRequest = {}) =>
    axios.get<PagedFeedbackResult>(`${BASE}/feedback/submitted`, {
      params: req,
      paramsSerializer: feedbackParamsSerializer,
    }).then(r => r.data),

  exportSubmitted: async (req: FeedbackListRequest = {}) => {
    const r = await axios.get<Blob>(`${BASE}/feedback/submitted/export`, {
      params: req,
      paramsSerializer: feedbackParamsSerializer,
      responseType: 'blob',
    })
    const blob = r.data
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    const ts = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 15)
    link.href = url
    link.setAttribute('download', `ai-interpretation-feedback_${ts}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  },
}
